// ========================================================
// FAST HIT Website — Announcement Strip
// CMS-controlled or default dismissible top announcement
// ========================================================

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Sparkles, ArrowRight } from 'lucide-react';
import { getActiveAnnouncement, type Announcement } from '../../services/cmsService';
import './AnnouncementStrip.css';

const DISMISS_KEY = 'fasthit_announcement_dismissed_';

export function AnnouncementStrip() {
  const [announcement, setAnnouncement] = useState<Announcement | null>(null);
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    getActiveAnnouncement().then((data) => {
      if (data) {
        setAnnouncement(data);
        const isDismissed = sessionStorage.getItem(DISMISS_KEY + data.id) === 'true';
        setDismissed(isDismissed);
      }
    });
  }, []);

  const handleDismiss = () => {
    if (announcement) {
      sessionStorage.setItem(DISMISS_KEY + announcement.id, 'true');
      setDismissed(true);
    }
  };

  if (!announcement || dismissed) return null;

  return (
    <div className="announcement-strip" role="region" aria-label="Announcement">
      <div className="announcement-strip__container">
        <div className="announcement-strip__content">
          <span className="announcement-strip__badge">
            <Sparkles size={12} />
            {announcement.badge || 'Update'}
          </span>
          <span className="announcement-strip__message">{announcement.message}</span>
          {announcement.linkUrl && (
            <Link to={announcement.linkUrl} className="announcement-strip__link">
              <span>{announcement.linkText || 'Learn More'}</span>
              <ArrowRight size={13} />
            </Link>
          )}
        </div>
        <button
          onClick={handleDismiss}
          className="announcement-strip__close"
          aria-label="Dismiss announcement"
        >
          <X size={15} />
        </button>
      </div>
    </div>
  );
}
